import { Box } from '@mui/material'
import LogoIcon from '../../assets/spark_transparent_white.png'
import { ContrastTypography } from '../Typographies/ContrastTypography'

interface LogoProps {
  companyName: string
  isRtl?: boolean
  open?: boolean
}

const Logo = (props: LogoProps) => {
  const { companyName, open = false } = props
  return (
    <Box display='flex' alignItems='center' justifyContent='flex-start' sx={{ cursor: 'pointer', width: '100%' }}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        sx={{
          width: '97px',
          minWidth: '97px',
          padding: '5px',
        }}
      >
        <img src={LogoIcon} alt='Company Logo' style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
      </Box>
      {open && (
        <Box flexGrow={1}>
          <ContrastTypography
            style={{
              width: '100%',
              textAlign: 'center',
              textTransform: 'uppercase',
              fontWeight: 700,
            }}
          >
            {companyName}
          </ContrastTypography>
        </Box>
      )}
    </Box>
  )
}

export default Logo
